import { render, staticRenderFns } from "./Classeurs.vue?vue&type=template&id=c4f7c12a"
import script from "./Classeurs.vue?vue&type=script&lang=js"
export * from "./Classeurs.vue?vue&type=script&lang=js"
import style0 from "./Classeurs.vue?vue&type=style&index=0&id=c4f7c12a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports